module.exports = __webpack_public_path__ + "static/media/number10.5b244a4b.svg";